<template lang="pug"></template>

<script>
export default {
    name: 'BotaoRastreabilidadeGestaoBungeSubEmpresa',
    componentOptions: {
        title: 'GestaoBungeSubEmpresa',
        actions: [
            [
                {
                    name: 'Gestão Rastreabilidade',
                    iconClass: 'lyra-icon bunge-rastreabilidade',
                    showView: false,
                    action: 'abrirGestao',
                    route: 'RastreabilidadeSubEmpresa',
                    nameTranslationKey: 'mensagens.menuLateral.rastreabilidade'
                }
            ]
        ]
    },

    methods: {
        abrirGestao() {
            if (this.$route.name !== 'RastreabilidadeSubEmpresa') {
                this.$router.push({ name: 'RastreabilidadeSubEmpresa' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
